/**
 * Calculator API service
 */
import api from './axios.config';
import type {
  LoanCalculationRequest,
  LoanCalculationResponse,
  AmortizationScheduleResponse,
} from '../../types';

export const calculatorApi = {
  /**
   * Calculate loan repayment details
   */
  calculateLoan: async (
    request: LoanCalculationRequest
  ): Promise<LoanCalculationResponse> => {
    const response = await api.post<LoanCalculationResponse>(
      '/api/v1/calculator/calculate',
      request
    );
    return response.data;
  },

  /**
   * Get amortization schedule
   */
  getAmortizationSchedule: async (
    request: LoanCalculationRequest
  ): Promise<AmortizationScheduleResponse> => {
    const response = await api.post<AmortizationScheduleResponse>(
      '/api/v1/calculator/amortization',
      request
    );
    return response.data;
  },

  /**
   * Calculate partial repayment impact
   */
  calculatePartialRepayment: async (request: any): Promise<any> => {
    const response = await api.post(
      '/api/v1/calculator/partial-repayment',
      request
    );
    return response.data;
  },
};
